import { component_tool, framework_tool } from '@/tool';
let { WizModal, WizNotice } = component_tool;
import moment from "moment";
import React from 'react';
import { WizTableForm } from "../../../common";
import NormalDealerAddList from "./normalDealerAdd/normalDealerAddList";
import NormalDealerImport from "./normalDealerAdd/normalDealerImport";
let { WizDataTable, WizIcon, WizButton, WizDivider, WizSurveyAudience, WizTypography, WizRow } = component_tool
let { WizAvatarUpload, ossFileUtils } = framework_tool

const organizationConfig = WizTableForm.Config.dealer(this, { apiParams: { state: 1, organizationNodeCategory:2 } })
let ref;
let ref_;
//配置项
let componentName = 'normalDealer'

const columns = [
  {
    name: 'id',
    formItem: { type: 'hidden' }
  },
  {
    title: '经销商名称',
    name: 'dealerName',
    searchItem: {},
    tableItem: {}
  },
  
  {
    title: '销售代码',
    name: 'preSalesNumber',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '售后代码',
    name: 'afterSalesNumber',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '品牌',
    name: 'orgId',
    searchItem: {
      ...organizationConfig,
      diy: WizTableForm,
      selectType: 'radio',
    }
  },
  {
    title: '开店状态',
    name: 'state',
    dataIndex: 'state',
    dict: [
      { code: 2, codeName: '建设中' },
      { code: 1, codeName: '已开店' },
      { code: 0, codeName: '已关店' }
    ],
    searchItem: {
      type: 'select'
    }
  },
  {
    title: '品牌',
    name: 'orgName',
    tableItem: {}
  },
  {
    title: '区域',
    name: 'regionName',
    tableItem: {}
  },
  {
    title: '开店状态',
    name: 'state',
    dataIndex: 'state',
    tableItem: {},
    dict: [
      { code: 2, codeName: '建设中' },
      { code: 1, codeName: '已开店' },
      { code: 0, codeName: '已关店' }
    ]
  }
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        dataFormat: (val) => {
          if (val['searchDate'] && val['searchDate'].length === 2) {
            val['startDate'] = moment(val['searchDate'][0]).format("YYYY-MM-DD")
            val['endDate'] = moment(val['searchDate'][1]).format("YYYY-MM-DD")
          }
          // delete val['searchDate']
          return val
        },
        buttonSort: ['add','delete','import', "export"],
        buttons: [
          // {
          //   key: "add",
          //   custom: true,
          //   params: { icon: "plus", children: "新增", type: "primary" },
          //   customOnClick: {
          //     key: "jumpPage",
          //     params: {
          //       key: "push",
          //       pathname: "/live/liveList/liveAdd"
          //     }
          //   }
          // },
          {
            key: "add",
            custom: true,
            params: { icon: "plus", children: "新增", type: "primary"},
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  title: "请选择所属组织",
                  diy: (e) => (
                    <NormalDealerAddList
                      {...e} key={new Date()}
                      ref={r => {
                        ref = r && r.getWrappedInstance();
                      }}
                    />
                  ),
                  onOk: () => {
                    ref._ok();
                  },
                  width: 1000
                }
              }
            }
          },
          // {
          //   key: "import",
          //   custom: true,
          //   params: { icon: 'import', children: '导入', type: 'import'},
          //   customOnClick: {
          //     key: "action",
          //     params: {
          //       apiKey: "exportLive"
          //     },
          //     formatParams: (rows, record, filter) => {
          //       return { ...filter };
          //     }
          //   }
          // },
          {
            key: "import",
            custom: true,
            params: { icon: 'import', children: '导入', type: 'import'},
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  title: "导入经销商",
                  diy: (e) => (
                    <NormalDealerImport
                      {...e} key={new Date()}
                      ref={r => {
                        ref_ = r && r.getWrappedInstance();
                      }}
                    />
                  ),
                  footer: false,
                  // onOk: () => {
                  //   ref_._ok();
                  // },
                  width: 1000
                }
              }
            }
          },

          {
            key: "export",
            custom: true,
            params: { icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "export"
              },
              formatParams: (rows, record, filter) => {
                return { ...filter };
              }
            }
          },
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false,
        // expandedRowRender: (record) => {
        //   return (
        //     <>
        //     <WizRow>
        //       <WizTypography.Paragraph strong>直播受众：</WizTypography.Paragraph>
        //     </WizRow>
        //     <WizSurveyAudience style={{width:1000}} labelWidth={4} data={record['authData']||{}} />
        //     </>
        //   )
        // }
      },
      rowOperateSort: [],
      rowOperateView: [
      ],
      commonOperate: {}
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },

}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
